import React from "react";
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { IsLoggedInUserViewer } from "../../hoc/withAuthRedirect";
import { t } from "i18next";

export const FormButtonToolbar = ({
  onCancelClick,
  onSubmitClick,
  isSubmitDisabled,
  buttonText,
  byPassRoleCheck
}) => {
  return (
    <ButtonToolbar aria-label="button-toolbar">
      <ButtonGroup aria-label="button-group" style={{ width: "100%" }}>
        <Button
          variant="outline-primary"
          id="cancel"
          onClick={onCancelClick}
          style={{
            width: "200px",
            borderRadius: "5px",
            borderColor: "#A62B23",
            color: "#A62B23",
            fontWeight: "bold",
            backgroundColor: "white",
            flex: "none",
          }}
        >
          {t("generic.cancel")}
        </Button>
        {byPassRoleCheck || !IsLoggedInUserViewer() ? (
          <>
            <div style={{ flexGrow: 1 }}></div>
            <Button
              variant="primary"
              type="submit"
              id="submit"
              onClick={onSubmitClick}
              disabled={isSubmitDisabled}
              style={{
                width: "200px",
                borderRadius: "5px",
                color: "white",
                borderColor: "#A62B23",
                backgroundColor: "#A62B23",
                flex: "none",
              }}
            >
              {buttonText ? buttonText : 'Submit for Approval'}
            </Button>
          </>) : ""}
      </ButtonGroup>
    </ButtonToolbar>
  );
};
